const state={
  // openId: '23333',
  // myOpenId: 'okITM5ib6-AUE3Ycri_8zmMaFdmw',
  userInfo: null,
  islogin:false,
  //登录弹窗
  showLogin:false,
  JSSDK: null,
  iconChartActive:[0,0,0,1],
  activePath:"",
  activePage:"",
  isCollapse:false,
  tableName:"",
  menuData: [],
  curApi: {},
  apiFirstTable: '',
  // plate:0,
}

const getters = {   //实时监听state值的变化(最新状态)
  getOpenid(state) {  //方法名随意,主要是来承载变化的showFooter的值
    return state.openId
  },
  getJSSDK(state){
    return state.JSSDK
  }
};

export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js